import createTableStore from "ds/components/Table/store/useTableStore";

import {
  STACK_PULL_REQUESTS_TABLE_COLUMNS_CONFIG,
  STACK_PULL_REQUESTS_TABLE_STORAGE_KEY,
} from "./constants";

const useStackPullRequestsTableStore = createTableStore({
  storageKey: STACK_PULL_REQUESTS_TABLE_STORAGE_KEY,
  config: STACK_PULL_REQUESTS_TABLE_COLUMNS_CONFIG,
});

export default useStackPullRequestsTableStore;
